import Buttons from "../../../../components/Buttons/Buttons";
import InputField from "../../../../components/Form/InputField";

import { ReactComponent as AutogenerateIcon } from '../../../../assets/Icons/adornments/Generate.svg';
import { ChangeEvent, Dispatch, SetStateAction, MouseEvent } from "react";
import { DataFile, EcleanCurationDAGRequestModel } from "../../../../api/models";
import TagsField from "../../../../components/Form/TagsField";
// import { useGetSupportedDataTypesDatasetSupportedColumnDataTypesGet } from "../../../../api/generated/fastAPI";

export default function SetDatasetParameters({
    form,
    setForm,
    chosenDatafile,
    showSelect,
}: {
    form: EcleanCurationDAGRequestModel,
    setForm: Dispatch<SetStateAction<EcleanCurationDAGRequestModel>>,
    chosenDatafile: DataFile | null,
    showSelect: boolean,
}) {
    // const getSupportedDataTypes = useGetSupportedDataTypesDatasetSupportedColumnDataTypesGet();


    const handleAddTag = (category: string, tag: string) => {
        let addedTag = '';

        if (category === 'general') {
            addedTag = tag;
        } else {
            addedTag = `${category}::${tag}`
        }

        setForm({
            ...form,
            tags: form.tags!.concat(addedTag),
        })
    }

    const handleRemoveTag = (index: number) => {
        setForm({
            ...form,
            tags: form.tags!.filter((t,i) => i !== index),
        })
    }

    const handleInput = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        })
    };

    const autoGenerateName = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        if (chosenDatafile) {
            setForm({
                ...form,
                name: chosenDatafile.name!.split('.')[0],
            })
        }
        
    };




    return (
        <>
            <div className="w-full flex justify-between items-end gap-4">
                <InputField 
                    label="Dataset name"
                    type='text'
                    id='name'
                    name='name'
                    value={form.name as string}
                    isRequired
                    handleChange={handleInput}
                />
                <Buttons
                    id='autogenerate-btn'
                    type='secondary'
                    styling="solid"
                    label='Autogenerate'
                    startingAdornment={<AutogenerateIcon/>}
                    action={autoGenerateName}
                />
            </div>
            <TagsField 
                label="Dataset"
                tags={form.tags! as string[]}
                showSelect={showSelect}
                menuPortalTarget={document.getElementById('generate-ds-popup')}
                handleAddTag={handleAddTag}
                handleRemoveTag={handleRemoveTag}
            />
        </>
    )
}